export const InvalidEmailMessage = "Please enter a valid email address";
export const SubmitErrorMessage = "There was a problem. Please try again";
export const EmptyWarningMessage = "";
